// Styles
import styles from './LoadingSpinner.module.sass'

interface LoaderProps {
  size: 'xs' | 'sm' | 'md'
  color?: 'white' | 'black'
}

const LoadingSpinner = ({ size, color = 'white' }: LoaderProps) => {
  return (
    <div
      className={`
      ${styles.loader}
      ${styles[`size-${size}`]}
      ${styles[`color-${color}`]}
    `}
    ></div>
  )
}

export default LoadingSpinner
